import React, {
  useEffect,
  useRef,
} from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';

import { Layout } from '@folio/stripes-components';

import { MIN_PASSWORD_LENGTH } from '../../constants';

import styles from './PasswordRequirementsList.css';

// The only password requirement is the minimum length, identical to the backend (mod-br-users)
// and to the other password flows (reset by an administrator, new publisher registration).
// The FOLIO tenant/rules complexity rules (digits, special characters, upper/lower case) are
// deliberately NOT used: they are neither enforced by the backend nor required anywhere else,
// so enforcing them only on the self-service reset page made the requirements inconsistent.
const LENGTH_REQUIREMENT_ID = 'password_length';
const LENGTH_REQUIREMENT_MESSAGE_ID = 'stripes-core.errors.password.length.invalid';

const PasswordRequirementsList = ({ passwordValue, onValidityChange }) => {
  const intl = useIntl();

  const isValid = (passwordValue?.length ?? 0) >= MIN_PASSWORD_LENGTH;

  // Guards against calling onValidityChange every render — only report when the boolean
  // actually flips, so the parent's setState can't cause a loop.
  const lastReportedValidity = useRef(null);

  useEffect(() => {
    if (lastReportedValidity.current !== isValid) {
      lastReportedValidity.current = isValid;
      onValidityChange(isValid);
    }
  }, [
    isValid,
    onValidityChange,
  ]);

  if (!passwordValue || isValid) {
    return null;
  }

  return (
    <Layout className="textLeft">
      <ul
        data-test-password-requirements-field
        className={styles.rulesList}
      >
        <li key={LENGTH_REQUIREMENT_ID}>
          {intl.formatMessage({ id: LENGTH_REQUIREMENT_MESSAGE_ID })}
        </li>
      </ul>
    </Layout>
  );
};

PasswordRequirementsList.propTypes = {
  passwordValue: PropTypes.string,
  onValidityChange: PropTypes.func,
};

PasswordRequirementsList.defaultProps = {
  onValidityChange: () => {},
};

export default PasswordRequirementsList;
